import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isProcessingMagicToken } = useAuth();

  const token = localStorage.getItem('access_token');

  // More robust authentication check
  const isAuthenticated = () => {
    if (!token) return false;

    try {
      // Optional: Add token expiration check if using JWT
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace('-', '+').replace('_', '/');
      const payload = JSON.parse(window.atob(base64));

      // Check if token is expired
      return payload.exp ? payload.exp > Math.floor(Date.now() / 1000) : true;
    } catch (error) {
      return false;
    }
  };

  // Only wait if magic token is actively being processed
  if (isProcessingMagicToken) {
    console.log('⏳ [ProtectedRoute] Magic token is being processed, waiting...');
    return null; // Or return a loading spinner
  }

  if (!isAuthenticated()) {
    console.log('🚫 [ProtectedRoute] Not authenticated, redirecting to login');
    // Redirect to login page but save the attempted location
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  console.log('✅ [ProtectedRoute] Authenticated, rendering protected content');
  return children;
};

export default ProtectedRoute;